// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summary-container {
    width: 50%;
    margin: 0 auto;
    text-align: left;
  }
  
  .summary-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
  }
  
  .summary-table td {
    padding: 5px 10px;
  }
  
  .total-row {
    font-weight: bold;
  }
  
  .grand-total {
    font-weight: bold;
    font-size: 1.2em;
  }
  
  .signature {
    text-align: right;
    margin-top: 40px;
  }
  
  .signature .line {
    width: 200px;
    height: 1px;
    background-color: black;
    margin: 0 auto 10px auto;
  }
  
  .signature p {
    margin: 0;
  }`, "",{"version":3,"sources":["webpack://./src/views/pages/end-customer/components/summary/summary.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,SAAS;EACX","sourcesContent":[".summary-container {\n    width: 50%;\n    margin: 0 auto;\n    text-align: left;\n  }\n  \n  .summary-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-bottom: 20px;\n  }\n  \n  .summary-table td {\n    padding: 5px 10px;\n  }\n  \n  .total-row {\n    font-weight: bold;\n  }\n  \n  .grand-total {\n    font-weight: bold;\n    font-size: 1.2em;\n  }\n  \n  .signature {\n    text-align: right;\n    margin-top: 40px;\n  }\n  \n  .signature .line {\n    width: 200px;\n    height: 1px;\n    background-color: black;\n    margin: 0 auto 10px auto;\n  }\n  \n  .signature p {\n    margin: 0;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
